import { MantineThemeOverride } from '@mantine/core';

export type TableTheme = NonNullable<MantineThemeOverride['components']>['Table'];

export const Table: TableTheme = {
  // todo: define
};
